module.exports = __webpack_public_path__ + "static/img/ent-detail-13.72a7b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-13.jpg
// module id = h6s7
// module chunks = 51